import { parsePhoneNumber } from 'libphonenumber-js';

export const formatAsE164 = (phoneNumber: string): string => {
	return parsePhoneNumber(phoneNumber, 'US')
		.formatInternational()
		.replace(/[^+\d]/g, '');
};
